module.exports = __webpack_public_path__ + "img/win_10.e9b089ba.png";